import React from 'react';
import "./Title.css";

export default function Title() {
  return (
    <>
      <h1 className='title'>MINT<span className='stroke new-line'>Nasty Goons</span></h1>
      <div className="collection-size">
          <h3 className="size-value">
              2,222
          </h3>
          <div className="label-container">
              <h4 className="label-collection">
                  Collection
              </h4>
              <h4 className="label-size">
                  Size
              </h4>
          </div>
      </div>
      <p className='description'>Nasty Toons may look harmless, but they retain all the powers of their Gooney counterparts, but with one key difference. They have a heart, and only a Nasty can take down a Gooney!</p>
      <div className='img-container'>
            <picture>
              <img className="nasty-img-mobile"
                          src="nasty-goon.jpg"
                          alt="background"/>
            </picture>
        </div>
    </>
  )
}
